import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Spin, Tabs } from 'antd';
import intl from 'react-intl-universal';
import LanguageTimeZone from './components/LanguageTimeZone';
import QuickEntry from './components/QuickEntry';
import Screen from './components/Screen';
import About from './components/About';
import QuickKey from './components/QuickKey';

import styles from './index.module.scss';

const BatchModifyModal: React.FC<any> = forwardRef((props, ref) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [activeKey, setActiveKey] = useState('screen');

  const tabOptions = [
    {
      label: intl.get('app_custom_quick_entry_screen'),
      key: 'screen',
      children: <Screen />,
    },
    {
      label: intl.get('app_custom_quick_entry_language_and_timezone'),
      key: 'languageTimeZone',
      children: <LanguageTimeZone />,
    },
    {
      label: intl.get('app_custom_quick_entry_shortcut_key'),
      key: 'quickKey',
      children: <QuickKey />,
    },
    {
      label: intl.get('app_custom_entry_quick_entry'),
      key: 'quickEntry',
      children: <QuickEntry />,
    },
    {
      label: intl.get('app_custom_quick_entry_about'),
      key: 'about',
      children: <About />,
    },
  ];

  // 打开弹窗
  const openModal = () => {
    setModalVisible(true);
  };

  // 暴露给父组件的方法,我需要传递过来参数
  const setTabKey = (v) => {
    setActiveKey(v);
  };

  useImperativeHandle(ref, () => ({
    openModal,
    setTabKey,
  }));

  // 关闭弹窗
  const closeModal = () => {
    setModalVisible(false);
    setActiveKey('screen');
  };

  return (
    <Modal
      title={intl.get('login_intl_setting')}
      width={960}
      visible={modalVisible}
      destroyOnClose
      maskClosable={false}
      onCancel={closeModal}
      footer={null}
      className={styles.systemSettingModal}
    >
      {console.log('key', activeKey)}
      <Tabs
        tabPosition="left"
        items={tabOptions}
        activeKey={activeKey || 'screen'}
        onChange={setActiveKey}
      />
    </Modal>
  );
});

export default BatchModifyModal;
